'use strict';
import {Component, Inject, Input} from 'ng-metadata/core';

@Component({
	'selector': 'prm-citation-trails-indication-container',
	templateUrl: 'components/search/citationTrails/citation-trails-indication-container.html',
})


export class PrmCitationTrailsIndicationContainer {
	@Input() public record: PrimoResponse.IExtendedDoc;

	constructor(@Inject('featuredActionsIcons') private actionsIcons) {
	}

	get citedby() {
		return this.record.extras.citationTrails.citedby;
	}

	get citing() {
		return this.record.extras.citationTrails.citing;
	}
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/citationTrails/citationTrailsIndicationContainer.directive.ts